<template>
  <div v-loading="loading">
    <!-- <flow-cate :all="true" :flowCates="cates" @selectCate="switchTypeId"></flow-cate> -->
    <flow-list :caseId="caseId" :path="path"></flow-list>
  </div>
</template>

<script>
  import flowCate from '../common/flowCate.vue'
  import flowList from '../common/flowList.vue'
  import http from '../../../assets/js/http'
  import flowCommon from '../mixins/flowCommon'

  export default {
    name: 'follow',
    data() {
      return {
        caseId: 1       // 我的待办
      }
    },
    created() {
      this.path = this.$route.path
      // this.getFlowCates()
    },
    components: {
      flowCate,
      flowList
    },
    beforeRouteEnter(to, from, next) {
      next(() => {
        to.meta.menu = from.meta.menu
        console.log(from)
        console.log(to)
      })
    },
    mixins: [http, flowCommon]
  }
</script>
<style>
.el-badge__content.is-fixed {
  top: 20px;
  right: 10px;
  position: absolute;
  -ms-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(100%);
}
</style>


// WEBPACK FOOTER //
// myFlow.vue?d6426e78